(function () {
  // Guard against double init (modal+script are rendered once, but be safe if
  // the snippet is ever included twice on a page).
  if (window.__pickupFlowInit) return;
  window.__pickupFlowInit = true;

  // querySelector by attribute — safe with defer (currentScript is null with defer)
  const script = document.querySelector('script[data-pickup-endpoint]');
  const endpoint = script && script.dataset.pickupEndpoint;

  // Localized strings passed from Liquid (| t) via data-attributes; RO fallback.
  const ds = (script && script.dataset) || {};
  const messages = {
    error: ds.msgError || 'A aparut o eroare. Incercati din nou.',
    successTitle: ds.msgSuccessTitle || 'Comanda plasata',
    successBody: ds.msgSuccessBody || 'Comanda __ORDER__ a fost inregistrata.',
    close: ds.msgClose || 'Inchide',
    sending: ds.msgSending || 'Se trimite...',
    submit: ds.msgSubmit || 'Confirma comanda',
    phoneInvalid: ds.msgPhoneInvalid || 'Numar de telefon invalid.',
    emailInvalid: ds.msgEmailInvalid || 'Adresa de email invalida.',
  };

  // Normalize to E.164 (Moldova +373) and validate, mirroring the server.
  function normalizePhone(raw) {
    let p = String(raw || '').replace(/[\s()\-.]/g, '');
    if (p.indexOf('00') === 0) p = '+' + p.slice(2);
    else if (p.indexOf('0') === 0) p = '+373' + p.slice(1);
    else if (p.indexOf('+') !== 0) p = '+373' + p;
    return p.replace(/^\+3730+/, '+373');
  }
  function validPhone(raw) {
    return /^\+373\d{8}$/.test(normalizePhone(raw));
  }

  // Email is required (it carries the marketing consent) — same rule as the server.
  function validEmail(raw) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(raw || '').trim());
  }

  const CHECK_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M5 13l4 4L19 7" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  let placed = false;       // an order was placed → closing reloads
  let submitting = false;   // request in flight → ignore close requests
  let lastFocused = null;   // element to restore focus to on close
  let pickupMode = 'delivery'; // tracked from any toggle (drawer or cart page)

  function modalEl() { return document.querySelector('[data-pickup-modal]'); }

  // Move the modal to <body> so position:fixed centers on the viewport,
  // escaping any transformed cart-drawer ancestor.
  function openModal() {
    const m = modalEl();
    if (!m) return;
    if (m.parentElement !== document.body) document.body.appendChild(m);
    lastFocused = document.activeElement;
    m.hidden = false;
    document.body.classList.add('pickup-lock');
    const first = m.querySelector('input, button');
    if (first) first.focus();
  }
  function closeModal() {
    if (submitting) return;
    if (placed) { window.location.reload(); return; }
    const m = modalEl();
    if (m) m.hidden = true;
    document.body.classList.remove('pickup-lock');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  // Track the delivery/pickup choice from any toggle (drawer or cart page).
  // Each toggle uses its own radio-group name (pickup-mode-<id>), so they stay
  // visually independent; we only care about the last choice the user made.
  document.addEventListener('change', function (e) {
    if (e.target.matches('input[name^="pickup-mode"]')) pickupMode = e.target.value;
  });

  // Checkout button (drawer or cart page): intercept when pickup is selected
  document.addEventListener('click', function (e) {
    if (!e.target.closest('button[name="checkout"]')) return;
    if (pickupMode === 'pickup') {
      e.preventDefault();
      openModal();
    }
  });

  // Close via cancel/×, close button, or click on the dark overlay
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pickup-cancel]') || e.target.closest('[data-pickup-close]')) {
      closeModal();
      return;
    }
    if (e.target.matches('[data-pickup-modal]')) closeModal();
  });

  // Keyboard: Escape closes, Tab is trapped inside the open modal
  document.addEventListener('keydown', function (e) {
    const m = modalEl();
    if (!m || m.hidden) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key !== 'Tab') return;
    const focusables = Array.prototype.filter.call(
      m.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Form submit
  document.addEventListener('submit', async function (e) {
    if (!e.target.matches('[data-pickup-form]')) return;
    e.preventDefault();
    const form = e.target;
    const errorEl = form.querySelector('[data-pickup-error]');
    const submitBtn = form.querySelector('[data-pickup-submit]');
    const labelEl = submitBtn.querySelector('.pickup-btn__label');
    const modal = modalEl();

    function setBusy(busy) {
      submitting = busy;
      submitBtn.disabled = busy;
      submitBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (labelEl) labelEl.textContent = busy ? messages.sending : messages.submit;
    }

    errorEl.hidden = true;

    // Validate phone client-side first — clear, localized, points to the field.
    if (!validPhone(form.phone.value)) {
      errorEl.textContent = messages.phoneInvalid;
      errorEl.hidden = false;
      form.phone.focus();
      return;
    }

    if (!validEmail(form.email.value)) {
      errorEl.textContent = messages.emailInvalid;
      errorEl.hidden = false;
      form.email.focus();
      return;
    }

    setBusy(true);

    try {
      const cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      const items = cart.items.map(function (i) {
        // Mirror whatever discount Shopify applied to this line in the cart — any
        // type: gift/BxGy, percentage, fixed amount, or an order-level discount
        // allocated to the line. Expressed as a % of the line so it is
        // quantity-independent and bounded to [0, 100].
        let discountPct = 0;
        if (i.original_line_price > 0 && i.total_discount > 0) {
          discountPct = (i.total_discount / i.original_line_price) * 100;
          if (discountPct > 100) discountPct = 100;
        }
        return {
          id: i.variant_id,
          quantity: i.quantity,
          discountPct: discountPct,
          discountTitle: (i.discounts && i.discounts[0] && i.discounts[0].title) || '',
        };
      });
      const payload = {
        name: form.name.value.trim(),
        phone: form.phone.value.trim(),
        email: form.email.value.trim(),
        acceptsMarketing: !!(form.marketing && form.marketing.checked),
        items: items,
      };
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) {
        errorEl.textContent = (data.errors && data.errors.join('. ')) || data.error || messages.error;
        errorEl.hidden = false;
        setBusy(false);
        return;
      }
      await fetch('/cart/clear.js', { method: 'POST' });
      submitting = false;
      placed = true;
      renderSuccess(modal, (data.order && data.order.name) || '');
    } catch (err) {
      errorEl.textContent = messages.error;
      errorEl.hidden = false;
      setBusy(false);
    }
  });

  // Build the success view. Static markup via innerHTML is our own; the
  // server-supplied order name is set with textContent (XSS-safe).
  function renderSuccess(modal, orderName) {
    const box = modal.querySelector('.pickup-modal__box');
    const parts = messages.successBody.split('__ORDER__');
    box.innerHTML =
      '<span class="pickup-modal__accent" aria-hidden="true"></span>' +
      '<div class="pickup-success">' +
        '<span class="pickup-success__check">' + CHECK_SVG + '</span>' +
        '<h3 class="pickup-modal__title"></h3>' +
        '<p class="pickup-success__body"></p>' +
        '<button type="button" class="pickup-btn pickup-btn--primary" data-pickup-close></button>' +
      '</div>';
    box.querySelector('.pickup-modal__title').textContent = messages.successTitle;

    const body = box.querySelector('.pickup-success__body');
    body.appendChild(document.createTextNode(parts[0] || ''));
    const order = document.createElement('span');
    order.className = 'pickup-success__order';
    order.textContent = orderName;
    body.appendChild(order);
    body.appendChild(document.createTextNode(parts[1] || ''));

    box.querySelector('[data-pickup-close]').textContent = messages.close;
    box.querySelector('[data-pickup-close]').focus();
  }
})();
